import { createApp } from 'vue';
import BlocklyTestView from '../views/blockly-test/BlocklyTestView.vue';

(window as any).conf = conf;

createApp(BlocklyTestView).mount('#app');
